import React from 'react';
import { BaasicInput, DatePicker, BaasicAsyncCreatableSelect } from 'core/components';
import _ from 'lodash';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';

 class LookupEditTemplate extends React.Component {
	static propTypes = {};

	constructor(props) {
		super(props);
		const {
			parentView,
			lookupEditViewStore: { form, loading, format },
		} = props;
		this.rootStore = parentView.rootStore;
		this.loading = loading;
		this.form = form;
		this.format = format;
		this.lookupViewStore = parentView;
		this.initialize();
	}
	initialize() {
		const itemParameters = this.lookupViewStore.selectedLookup.parameters;
		const { itemName } = itemParameters;
		const { t } = this.props;
		// Render extra fields if any
		this.extraFields = [];
		this.form.fields.data_.forEach( item => {
			if (item.value_.key !== 'name') {
				var extraField;
				let field = this.form.$(item.value_.key);
				if (field.extra) {
					switch (field.extra.type) {
						case 'DatePicker': {
							extraField = (
								<div className="col col-sml-12 col-med-6" key={item.value_.key}>
									<DatePicker
										key={item.value_.key}
										field={field}
										withoutYear={true}
										form={this.form}
										format={this.format}
										rootStore={this.rootStore}
									/>
								</div>
							);
							break;
						}
						case 'Lookup': {
							extraField = (
								<div className="col col-sml-12 col-med-12" key={item.value_.key}>
										<BaasicAsyncCreatableSelect
											key={item.value_.key}
											service={field.extra.service}
											field={field}
											value={field.value}
											searchBy={field.extra.searchBy}
											multi={false}
											creatable={false}
										/>
								</div>
							);
							break;
						}
					}
				} else {
					extraField = (
						<div className="col col-sml-12" key={item.value_.key}>
							<BaasicInput key={item.value_.key} field={field} />
						</div>
					);
				}
				this.extraFields.push(extraField);
			}
		});
		this.modalTitle =
			this.rootStore.routerStore.routerState.queryParams['create'] !== undefined ? t('CREATE') : t('EDIT');
		this.itemName = itemName;
	}

	render() {
		const { t } = this.props;
		return (
			<form className="ReactModal__form" onSubmit={this.form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">
						{t(this.modalTitle)} {t(_.startCase(this.itemName))}
					</h3>
				</div>
				<div className="ReactModal__body">
					<div className="row">
						{this.form.has('name') && (
							<div className="col col-sml-12">
								<BaasicInput autoFocus field={this.form.$('name')} />
							</div>
						)}
						{this.extraFields}
					</div>
					{this.form.error && (
						<div>
							<p className="type--color--warning spc--bottom--sml">{translate(this.form.error)}</p>
						</div>
					)}
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
						{this.loading ? (
							<div className="spinnercont spc--right--sml">
								<div className="spinner"></div>
							</div>
						) : null}
						{t('SAVE')}
					</button>
				</div>
			</form>
		);
	}
}

export default defaultTemplate(LookupEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/lookup/pages/LookupEditTemplate.jsx